import {
  useFollowParentSchedulePreview,
  type UseFollowParentSchedulePreviewResult,
} from '@/shared/hooks/useFollowParentSchedulePreview'
import type { WeekdaySchedule } from '@/shared/ui/weekly-schedule-grid'

interface UseFollowParentSiteSchedulePreviewArgs {
  /** When false (no nested unit Follow Site ON), no partial reloads run. */
  enabled: boolean
  siteId: number | null
  parentDaySchedule: WeekdaySchedule | undefined
  /** Site the server preview was built for (`null` on New); a different form site triggers a reload. */
  initialSiteId?: number | null
  /** Bump after exhausted preview to retry without disabling all nested Follow rows. */
  retryNonce?: number
}

/**
 * Live site day-schedule preview while Follow Site is ON on Departments create
 * and edit nested units. Thin wrapper around useFollowParentSchedulePreview (E46-S2).
 */
export const useFollowParentSiteSchedulePreview = ({
  enabled,
  siteId,
  parentDaySchedule,
  initialSiteId = null,
  retryNonce = 0,
}: UseFollowParentSiteSchedulePreviewArgs): UseFollowParentSchedulePreviewResult =>
  useFollowParentSchedulePreview({
    enabled,
    parentId: siteId,
    parentDaySchedule,
    initialParentId: initialSiteId,
    retryNonce,
    reloadParamKey: 'site_id',
  })
